/**
 * Подписывается на публичный канал уведомлений, перезагружает страницу,
   если пользователь авторизовался с помощью Telegram
 */

const subscriber = (rt) => {
  rt.subscribePublic("telegram-auth", data => {
    console.log('telegram-auth', data);
    if (data.authKey === localStorage.authKey) {
      window.location.reload();
    }
  });
}

export default subscriber;